import axiosInstance from '../RestClient';

const BASE_URI = '/payments';
class PaymentService {
	async list() {
		const uri = `${BASE_URI}/`;
		const response = await axiosInstance.get(uri);
		return response;
	}
	async search(query) {
		const uri = `${BASE_URI}/search?${query}`;
		const response = await axiosInstance.get(uri);
		return response;
	}
	async getDetails(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async create(payload) {
		const response = await axiosInstance.post(`${BASE_URI}/`, payload);
		return response;
	}

	async edit(recordId, payload) {
		const response = await axiosInstance.put(`${BASE_URI}/${recordId}`, payload);
		return response;
	}

	async delete(recordId) {
		const uri = `${BASE_URI}/${recordId}`;
		const response = await axiosInstance.delete(uri);
		return response;
	}

	async getPaymentsForAccount(accountId) {
		const uri = `${BASE_URI}/mine/${accountId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async getPaymentsForDebt(debtId) {
		const uri = `${BASE_URI}/minedebt/${debtId}`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async uploadComprobante(formData) {
		const uri = `${BASE_URI}/uploadComprobante`;
		const response = await axiosInstance.post(uri, formData, {
			headers: { 'Content-Type': undefined },
		});
		return response;
	}

	async getWithDocuments() {
		const uri = `${BASE_URI}/withDocuments`;
		const response = await axiosInstance.get(uri);
		return response;
	}

	async downloadReceipt(paymentId) {
		const response = await axiosInstance.get(`${BASE_URI}/${paymentId}/receipt/pdf`, {
			responseType: 'blob',
		});
		const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
		const link = document.createElement('a');
		link.href = url;
		link.download = `recibo-${paymentId}.pdf`;
		link.click();
		URL.revokeObjectURL(url);
	}

	async sendReceiptByEmail(paymentId, email) {
		const response = await axiosInstance.post(`${BASE_URI}/${paymentId}/receipt/email`, { email });
		return response;
	}

	async getClientPhone(paymentId) {
		const response = await axiosInstance.get(`${BASE_URI}/${paymentId}/client-phone`);
		return response.data.clientPhone;
	}

	async createReceiptShareLink(paymentId) {
		const response = await axiosInstance.post(`${BASE_URI}/${paymentId}/receipt/share`);
		return response;
	}

	async getReceiptBlob(paymentId) {
		const response = await axiosInstance.get(`${BASE_URI}/${paymentId}/receipt/pdf`, {
			responseType: 'blob',
		});
		return new Blob([response.data], { type: 'application/pdf' });
	}
}
export default new PaymentService();
